export const STUDENT_PLAN_DESCRIPTION = (
  <>
    Free for students with GitHub’s Student Developer Pack access. <br />A single user account for debugging, testing in
    CI, and more.
  </>
);
